// @flow
import { connect } from 'react-redux';

import { fetchAllContactForm7Forms } from 'actions/contactForm7Actions';
import CF7FormObjectSelector from 'components/contactForm7/CF7FormObjectSelector';
import type { DispatchProps, StateProps } from 'components/contactForm7/CF7FormObjectSelector';
import type { DispatchType, StateType } from 'types/Actions';

const mapStateToProps = (state: StateType): StateProps => ({
  contactFormList: state.contactForm7State.contactFormList
});

const dispatchStateToProps = (dispatch: DispatchType): DispatchProps => ({
  fetchAllContactForms: () => dispatch(fetchAllContactForm7Forms())
});

export default connect(mapStateToProps, dispatchStateToProps)(CF7FormObjectSelector);
